import {Theme} from "@mui/material";
import { jsx, css } from "@emotion/react"
import {UploadFormProps} from "./UploadForm";

const styles = (theme: Theme, props: UploadFormProps) => ({
})
export default styles;
